/**
 * Models a user object
 */

import Brace from "backbone.brace";
import Shard from "./shard";
import Shards from "../collections/shards";
import environment from "../common/environment";

import Gravatar from "../utils/gravatar";

const Model = Brace.Model.extend({
  urlRoot: environment.getEndpoint("user"),

  namedAttributes: {
    id: Number,
    username: String,
    email: String,
    fullName: String,
    photoURL: String,
    siteAdmin: Boolean,
    shards: Shards,
    defaultShard: Shard,
    defaultRoute: String,
  },

  defaults: {
    id: null,
    username: null,
    email: null,
    fullName: null,
    photoURL: null,
    siteAdmin: false,
    shards: [],
    defaultShard: null,
    defaultRoute: null,
  },

  initialize() {
    // listen for initial change
    this.listenToOnce(this, "change", this._onChange);

    // fetch profile
    this.promise = this.fetch();
  },

  _onChange() {
    // Try Gravatar when no photo exists.
    if (!this.getPhotoURL()) {
      const gravatar = new Gravatar(this.getEmail());
      // update model
      this.set({
        photoURL: gravatar.getImage(),
      });
    }

    // mark active shard when available
    if (this.getDefaultShard()) {
      try {
        const id = this.getDefaultShard().getId();
        this.getShards().get(id).setChecked(true);
      } catch (e) {
        // ignore this error
      }
    }
  },
});

export { Model as default };
